import React from "react";
import LookupsAPI from "../API/lookups.api";

const reformatCurrency = (currency) => ({
    ...currency,
    currencyName: currency.label,
    label: (
        <>
            <i className={`fas fa-${currency.label}-sign`}></i>
            <span className="w-6/12 text-justify inline mr-2">
                {` ${currency.abbreviation}`}
            </span>
        </>
    ),
});

const getCurrencyDropdown = async (selectSetter, usdSetter) => {
    try {
        const result = await LookupsAPI.getCurrencies();
        const selectReady = result.map((currency) => {
            const labelVal = reformatCurrency(currency);
            if (usdSetter && currency.abbreviation === "USD")
                usdSetter((prevState) => {
                    return {
                        ...prevState,
                        currency: labelVal,
                    };
                });
            return labelVal;
        });
        selectSetter(selectReady);
    } catch (e) {
        console.log(e);
    }
};

export { reformatCurrency, getCurrencyDropdown };
